import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from "react-helmet-async";

function PhotoGallery() {
  return (
    <>
    <Helmet>
        <title> Photo Gallery of Rodwell House </title>
        <meta
          name="description"
          content="A photo gallery of Rodwell House, showcasing our residents, staff, and facilities."
        />
        <link rel="canonical" href="https://www.whitstable.house/photo-gallery"/>
      </Helmet>

    <div className="page">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />

      <main id="main-content">
        <section className="content-section photo-gallery-page">
          <div className="photo-gallery-container">
            <h1>Photo Gallery</h1>
          </div>
        </section>

        <section className="photo-gallery-grid">
          <div className="gallery-grid">
              <div className="gallery-item">
                <img src="/hero-image-2.jpg" alt="Rodwell House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-3.jpg" alt="Rodwell House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-4.jpg" alt="Rodwell House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-5.jpg" alt="Rodwell House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-6.jpg" alt="Rodwell House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-7.jpg" alt="Rodwell House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-8.jpg" alt="Rodwell House" />
              </div>
              <div className="gallery-item">
                <img src="/hero-image-9.jpg" alt="Rodwell House" />
              </div>
              <div className="gallery-item">
                <img src="/whitstable-suite-image.jpg" alt="Care Suite" />
              </div>
              <div className="gallery-item">
                <img src="/whitstable-suite-image-2.jpg" alt="Care Suite" />
              </div>
              <div className="gallery-item">
                <img src="/whitstable-suite-image-3.jpg" alt="Care Suite" />
              </div>
              <div className="gallery-item">
                <img src="/whitstable-suite-main-room.jpg" alt="Care Suite Main Room" />
              </div>
            </div>
        </section>
      </main>

      <footer className="footer">
        <section className="footer__enquiry">
          <div className="footer__enquiry-container">
            <Link to="/contact-us" className="footer__enquiry-link">
              Enquire about Graham Care <span className="footer__arrow">▶</span>
            </Link>
          </div>
        </section>
        <div className="footer__container">
          <section className="contact-section">
            <div className="contact-section__content">
              <p>Graham Care Ltd, KT15 1HH</p>
              <p>Copyright © Graham Care Ltd</p>
            </div>
          </section>
        </div>
      </footer>
    </div>
    </>
  );
}

export default PhotoGallery;
